// extracted by mini-css-extract-plugin
export default {"modal":"DeleteModal_modal__hwe+0","deleteModal":"DeleteModal_deleteModal__lrvZz","icon":"DeleteModal_icon__UkIY3"};